import React, { useEffect, useState } from 'react';
import {
    Alert, Box, Button, Card, CardContent, FormControlLabel, Stack, Switch, TextField, Typography,
} from '@mui/material';
import { TEXT_TICHY_REZIM } from '../../api/JsdhNotifikaceService/service/OdpojeniService';
import {
    useOdpojeniTichyRezimQuery, useUlozTichyRezimMutation,
} from '../../api/JsdhNotifikaceService/service/OdpojeniMutations';

const CAS = /^([01]\d|2[0-3]):[0-5]\d$/;

/**
 * Společný tichý režim (spec oddíl 5.4 a 7): přepínač a okno Od–Do v čase Europe/Prague, může přes půlnoc.
 * Vypnutý = oba časy null. Platí pro všechny druhy, proto se zobrazuje i bez MODUL_IOT.
 */
const TichyRezimKarta: React.FC = () => {
    const { data, error } = useOdpojeniTichyRezimQuery();
    const uloz = useUlozTichyRezimMutation();
    const [zapnuto, setZapnuto] = useState(false);
    const [od, setOd] = useState('22:00');
    const [doCasu, setDoCasu] = useState('06:00');

    useEffect(() => {
        if (!data) {
            return;
        }
        setZapnuto(!!data.tichyOd && !!data.tichyDo);
        if (data.tichyOd) {
            setOd(data.tichyOd);
        }
        if (data.tichyDo) {
            setDoCasu(data.tichyDo);
        }
    }, [data]);

    // Spec 8: stejné časy se neodmítají, BE je uloží jako vypnutý režim; karta to jen vysvětlí.
    const stejne = od === doCasu;
    const platne = !zapnuto || (CAS.test(od) && CAS.test(doCasu));
    // Bez načteného stavu by uložení poslalo {null, null} a tiše vypnulo existující okno.
    const ulozit = () => uloz.mutate(zapnuto ? { tichyOd: od, tichyDo: doCasu } : { tichyOd: null, tichyDo: null });

    return (
        <Card variant="outlined" sx={{ mb: 2 }} data-testid="odpojeni-tichy-rezim">
            <CardContent>
                <Stack spacing={2}>
                    <Box>
                        <Typography variant="h6" component="h2">Tichý režim</Typography>
                        <Typography variant="body2" color="text.secondary">{TEXT_TICHY_REZIM}</Typography>
                    </Box>
                    {error && <Alert severity="error">Tichý režim se nepodařilo načíst.</Alert>}
                    <FormControlLabel
                        control={<Switch checked={zapnuto} onChange={(e) => setZapnuto(e.target.checked)} />}
                        label="Zapnout tichý režim"
                    />
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                        <TextField
                            id="tichy-od"
                            label="Od"
                            type="time"
                            value={od}
                            onChange={(e) => setOd(e.target.value)}
                            disabled={!zapnuto}
                            InputLabelProps={{ shrink: true }}
                        />
                        <TextField
                            id="tichy-do"
                            label="Do"
                            type="time"
                            value={doCasu}
                            onChange={(e) => setDoCasu(e.target.value)}
                            disabled={!zapnuto}
                            helperText={zapnuto && stejne ? 'Stejný začátek a konec znamená vypnuto.' : ' '}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Stack>
                    <Box>
                        <Button variant="contained" onClick={ulozit} disabled={!data || !platne || uloz.isPending}>
                            Uložit
                        </Button>
                    </Box>
                </Stack>
            </CardContent>
        </Card>
    );
};

export default TichyRezimKarta;
